import axios from 'axios';
import WebFont from 'webfontloader';

window.axios = axios;
window.WebFont = WebFont;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
